import React, { Component } from "react";
import PropTypes from "prop-types";
import { Dialog, Classes } from "@blueprintjs/core";
import { BaseButton, BUTTON_TYPE, SIZE } from "prefab";
import StatusIcon from "../StatusIcon";
import { CAMPAIGN_STATUS_LIST, STATUS_ICON_TYPES } from "../../../constants";
import ButtonStyles from "../../../styles/Button.module.scss";
import { WarningCircle } from "../../../assets";
import styles from "./DuplicateCampaignWarning.module.scss";

const INITIAL_VISIBLE_CAMPAIGNS = 2;

const getStatusColor = (status) => {
  const statusItem = CAMPAIGN_STATUS_LIST.find((item) => item.id === status);
  return statusItem ? statusItem.color : "";
};

class DuplicateCampaignWarning extends Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onIgnoreAndSave: PropTypes.func.isRequired,
    thirdPartyCampaignId: PropTypes.string,
    campaigns: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        code: PropTypes.string,
        name: PropTypes.string,
        status: PropTypes.string,
      })
    ),
  };

  static defaultProps = {
    campaigns: [],
    thirdPartyCampaignId: "",
  };

  state = {
    expanded: false,
  };

  renderConflictTable = () => {
    const { campaigns } = this.props;
    const { expanded } = this.state;
    const visibleCampaigns = expanded ? campaigns : campaigns.slice(0, INITIAL_VISIBLE_CAMPAIGNS);
    const hiddenCount = campaigns.length - INITIAL_VISIBLE_CAMPAIGNS;

    return (
      <>
        <div className={styles.tableWrapper}>
          <table className={styles.conflictTable}>
            <thead>
              <tr>
                <th>Campaign</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {visibleCampaigns.map((campaign) => (
                <tr key={campaign.id}>
                  <td>
                    <a
                      className={styles.campaignLink}
                      href={`/campaigns/campaigns/${campaign.id}/details`}
                      target="_blank"
                      rel="noopener noreferrer"
                      title={`${campaign?.code}:${campaign?.name}`}
                    >
                      {campaign?.code}:{campaign.name}
                    </a>
                  </td>
                  <td>
                    <div className={styles.statusItem}>
                      <StatusIcon
                        color={getStatusColor(campaign.status)}
                        type={STATUS_ICON_TYPES.CIRCLE}
                      />
                      <span>{campaign.status}</span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {!expanded && hiddenCount > 0 && (
          <button
            className={styles.showMoreToggle}
            onClick={() => this.setState({ expanded: true })}
          >
            + {hiddenCount} more
          </button>
        )}
      </>
    );
  };

  render() {
    const { isOpen, onClose, onIgnoreAndSave, thirdPartyCampaignId, campaigns } = this.props;

    if (!campaigns || campaigns.length === 0) return null;

    const count = campaigns.length;

    return (
      <Dialog
        isOpen={isOpen}
        onClose={onClose}
        icon={<WarningCircle width={25} height={25} style={{ marginRight: 8 }} />}
        title="Duplicate Third-Party Campaign ID warning"
        isCloseButtonShown={true}
        className={styles.duplicateCampaignWarningDialog}
      >
        <div className={Classes.DIALOG_BODY}>
          <div className={styles.conflictSection}>
            <div className={styles.conflictMessage}>
              Third Party Campaign ID{" "}
              <span className={styles.boldText}>{thirdPartyCampaignId}</span> is already used in{" "}
              <span className={styles.boldText}>{count}</span> other campaign
              {count > 1 ? "s" : ""}.
            </div>
            {this.renderConflictTable()}
          </div>
        </div>
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <BaseButton
              onClick={onIgnoreAndSave}
              buttonText="Ignore & Save"
              buttonSize={SIZE.SMALL}
              className={ButtonStyles.buttonSpacing}
            />
            <BaseButton
              onClick={onClose}
              buttonText="Cancel"
              buttonSize={SIZE.SMALL}
              buttonType={BUTTON_TYPE.PRIMARY}
            />
          </div>
        </div>
      </Dialog>
    );
  }
}

export default DuplicateCampaignWarning;
